import { render, staticRenderFns } from "./organizeModal.vue?vue&type=template&id=0b0b3b5a&"
import script from "./organizeModal.vue?vue&type=script&lang=js&"
export * from "./organizeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports